import { useTheme } from '@emotion/react';
import { Grid, Skeleton, TableBody, TableRow } from '@mui/material';
import { BodyTableCell } from 'framework/desktop/AryTableCell';
import React from 'react';

const AryNewTableSkeleton = ({
  numOfRows = 50,
  hideLastRowBorder,
  isFlat,
  columns
}) => {
  const theme = useTheme();

  // Get visible columns based on initialVisibility property
  const getVisibleColumns = () =>
    Object.keys(columns).filter((columnName) => {
      const column = columns[columnName];
      return column.initialVisibility !== false;
    });

  const visibleColumns = getVisibleColumns();

  return (
    <TableBody>
      {Array(numOfRows)
        .fill(true)
        .map((_, index) => (
          <TableRow
            key={index}
            sx={{
              '&:last-child td, &:last-child th': {
                border: hideLastRowBorder && 0
              },
              backgroundColor: isFlat
                ? ''
                : index % 2 === 1 && theme.table.darkRow.backgroundColor
            }}
          >
            {visibleColumns?.map((columnName, innerIndex) => {
              const column = columns[columnName];

              const cellSx =
                column?.cellSx && column?.cellSx(_, column.key, innerIndex);
              return (
                <BodyTableCell
                  key={innerIndex}
                  sx={{
                    p: 2,
                    textAlign: 'center',
                    ...cellSx
                  }}
                >
                  <Grid
                    container
                    justifyContent={
                      cellSx?.textAlign ? cellSx?.textAlign : 'center'
                    }
                  >
                    <Skeleton
                      height={25}
                      width={column.isSkCircular ? 25 : '80%'}
                      variant={column.isSkCircular && 'circular'}
                    />
                  </Grid>
                </BodyTableCell>
              );
            })}
          </TableRow>
        ))}
    </TableBody>
  );
};

export default AryNewTableSkeleton;
